import Vue from 'vue';

export class EventBus {
  events;

  constructor() {
    this.events = {};
  }

  // 监听事件
  $on(event, listener) {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(listener);
    return this;
  }

  // 监听一次事件
  $once(event, listener) {
    const onceListener = (...args) => {
      listener.apply(this, args);
      this.$off(event, onceListener);
    };
    this.$on(event, onceListener);
    return this;
  }

  // 触发事件
  $emit(event, ...args) {
    if (this.events[event]) {
      this.events[event].forEach(listener => listener.apply(this, args));
    }
    return this;
  }

  // 移除事件监听
  $off(event, listener) {
    if (this.events[event]) {
      this.events[event] = this.events[event].filter(l => l !== listener);
    }
    return this;
  }
}

export default new Vue();
